import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import './assets/css/main.css';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import VueCookies from 'vue-cookies'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import './tailwind.css'


Vue.config.productionTip = false

// --== Global filters. ==--
// timestamp filter
Vue.filter('timestampToDate', function (timestamp) {
  if (!timestamp) return ''

  let auctionDate = new Date(timestamp)
  return (auctionDate.getMonth() + 1) + '/' + auctionDate.getDate() + '/' + auctionDate.getFullYear()
})

Vue.filter('timestampToTime', function (timestamp) {
  if (!timestamp) return ''

  let auctionDate = new Date(timestamp)
  return auctionDate.getHours() + ':' + (auctionDate.getMinutes() < 10 ? '0' : '') + auctionDate.getMinutes()
})

// money display filter
Vue.filter('numberToMoney', function (num, showChange=true) {
  if (!num) return ''

  return parseFloat(num).toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: showChange ? 2 : 0,
    maximumFractionDigits: showChange ? 2 : 0
  })
})

// Bring in vue-cookies
Vue.use(VueCookies)

// Bring in the WYSIWYG plugin
Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi'
})

Vue.use(VueTelInputVuetify, {
  vuetify
})

// --== Create Vue instance. ==--
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
